import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';
import { hasSessionToken, isSessionExpired } from './auth-session-utils';

export const authGuardGuard: CanActivateFn = (route, state) => {

  const _router = inject(Router);
  const _auth = inject(Auth);

  _auth.setRedirectUrl(state.url);

  if (!hasSessionToken()) {

    return _router.createUrlTree(['login']);
  }

  if (isSessionExpired()) {

    _auth.setSessionExpired();
    _auth.clearAuthStorage();

    return _router.createUrlTree(['login']);
  }

  if (localStorage.getItem('email_verify') === null || localStorage.getItem('email_verify') === 'false') {

    return _router.createUrlTree(['valida-email']);
  }

  if (localStorage.getItem('abilities')?.includes('senhaInsegura')) {

    return _router.createUrlTree(['troca-senha']);
  }

  return true;
};